import React from 'react'
import SolutionIntroSection from './SolutionIntroSection'
import ServicesSection from './ServicesSection'

function Services() {
  return (
    <>
    <SolutionIntroSection />
    <ServicesSection />    
    </>
  )
}

export default Services